import { fetchIfLoggedIn } from '../utils.js'
import * as actions from 'actions'

export const getMfaSettings = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_MFA_SETTINGS,
      method: 'get',
      path: '/mfa/configuration',
    })
  )
}

export const updateMfaSettings = data => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.UPDATE_MFA_SETTINGS,
      method: 'post',
      path: '/mfa/configuration',
      postBody: data,
    })
  )
}

export const getStepupSettings = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_STEP_UP_SETTINGS,
      method: 'get',
      path: '/step-up/configuration',
    })
  )
}

export const updateStepupSettings = data => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.UPDATE_STEP_UP_SETTINGS,
      method: 'post',
      path: '/step-up/configuration',
      postBody: data,
    })
  )
}
